import * as z from "zod/v4";

export const getRiseAiIntegration = {
  name: "getRiseAiIntegration" as const,
  input: z.object({}),
  output: z.object({
    riseAiIntegration: z.optional(
      z.object({
        enabled: z.boolean(),
        riseAccountId: z.string(),
        triggerKey: z.string(),
      }),
    ),
  }),
};

export type GetRiseAiIntegrationOutput = z.infer<
  typeof getRiseAiIntegration.output
>;

export const setRiseAiIntegration = {
  name: "setRiseAiIntegration" as const,
  input: z.object({
    enabled: z.boolean(),
    riseAccountId: z.string().min(1, "Rise Account ID is required"),
    authToken: z.string().min(1, "Auth Token is required"),
    triggerKey: z.string().min(1, "Trigger Key is required"),
  }),
  output: z.object({}),
};

export const updateRiseAiIntegration = {
  name: "updateRiseAiIntegration" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    riseAccountId: z.string().min(1, "Rise Account ID is required").optional(),
    authToken: z.string().min(1, "Auth Token is required").optional(),
    triggerKey: z.string().min(1, "Trigger Key is required").optional(),
  }),
  output: z.object({}),
};

export const disconnectRiseAiIntegration = {
  name: "disconnectRiseAiIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
